// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1rOdO","title":"InfoRow_title__3WDfg"};